export class EnrollmentSource {
    readonly Banner: string = 'Banner';
    readonly UNEX: string = 'UNEX';
    readonly iGrade: string = 'iGrade';

    static getInstance(): EnrollmentSource {
        return new EnrollmentSource();
    }
}
